<template>
    <div
        class="modal fade"
        id="modalFinishService"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalFinishServiceLabel"
        aria-hidden="true"
        ref="modal"
    >
        <div class="modal-dialog modal-dialog-centered finish-service-dialog" role="document">
            <div class="modal-content finish-service-modal">
                <div class="modal-header border-0 pb-0">
                    <div>
                        <h5 class="modal-title" id="modalFinishServiceLabel">Selesaikan Servis</h5>
                        <p class="modal-subtitle mb-0">Lengkapi detail penyelesaian di bawah ini sebelum menyelesaikan servis.</p>
                    </div>
                    <button type="button" class="close" @click="closeModal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <hr class="modal-divider" />

                <div class="modal-body pt-0">
                    <div class="ringkasan-box">
                        <div class="section-header">RINGKASAN SERVIS</div>
                        <div class="section-body">
                            <div class="row">
                                <div class="col-lg-4">
                                    <p class="summary-label">Nama Vendor</p>
                                    <p class="summary-value">{{ serviceInfo.vendorName || '-' }}</p>
                                </div>
                                <div class="col-lg-4">
                                    <p class="summary-label">Tanggal Dibuat</p>
                                    <p class="summary-value">{{ serviceInfo.createdAt || '-' }}</p>
                                </div>
                                <div class="col-lg-4">
                                    <p class="summary-label">Dibuat Oleh</p>
                                    <p class="summary-value">{{ serviceInfo.createdByName || '-' }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <p class="item-list-label">Daftar Item Dipilih</p>

                    <div
                        v-for="(item, index) in items"
                        :key="`finish-item-${index}`"
                        class="item-box"
                    >
                        <div class="section-header">ITEM {{ index + 1 }}</div>
                        <div class="section-body">
                            <p class="field-label">Nama Item</p>
                            <p class="field-value">{{ item.itemName }}</p>

                            <hr class="item-divider" />

                            <template v-if="item.snBatchNumber">
                                <p class="field-label">
                                    Serial Number/Batch Number
                                    <span class="lama-badge">Lama</span>
                                </p>
                                <p class="field-value">{{ item.snBatchNumber }}</p>

                                <hr class="item-divider" />
                            </template>

                            <input-radio
                                label="Metode Penyelesaian"
                                :name="`metode-${index}`"
                                type="horizontal"
                                style-type="button"
                                :options="resolutionOptions"
                                :value="item.resolutionMethod"
                                @change="item.resolutionMethod = $event"
                            />

                            <div class="toggle-row">
                                <span class="toggle-label">Kenakan Biaya Servis</span>
                                <toggle-switch :value="item.chargeServiceFee" @change="item.chargeServiceFee = $event" />
                            </div>
                            <div v-if="item.chargeServiceFee" class="mt-2">
                                <input-currency
                                    :id="`fee-${index}`"
                                    :value="item.serviceFee"
                                    placeholder="0"
                                    :show-prefix-label="true"
                                    @change="item.serviceFee = $event"
                                >
                                    <template #prefix-label>Rp</template>
                                </input-currency>
                            </div>

                            <template>
                                <div class="toggle-row">
                                    <span class="toggle-label">SN/Batch Number Berubah</span>
                                    <toggle-switch :value="item.snBatchChanged" @change="item.snBatchChanged = $event" />
                                </div>
                                <div v-if="item.snBatchChanged" class="mt-2">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Masukan serial number/batch number baru"
                                        v-model="item.newSnBatch"
                                    />
                                    <input
                                        type="text"
                                        class="form-control mt-2"
                                        placeholder="Masukan kode stok baru"
                                        v-model="item.newStockCode"
                                        v-if="item.cfSerialNumber"
                                    />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <hr class="modal-divider" />

                <div class="modal-footer border-0 pt-0">
                    <button type="button" class="btn btn-outline-secondary btn-kembali" @click="closeModal">
                        Kembali
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary btn-selesaikan"
                        :disabled="!isFormValid || loading"
                        @click="simpan"
                    >
                        <img src="~@/assets/images/2.gif" style="height: 24px" v-if="loading" />
                        {{ loading ? 'Memproses...' : 'Selesaikan Servis' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { alert } from "@/utils/alert";
import { InputRadio, ToggleSwitch, InputCurrency } from '../../Input';

export default {
    name: 'ModalFinishService',
    components: {
        InputRadio,
        ToggleSwitch,
        InputCurrency,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            serviceInfo: {},
            items: [],
            resolutionOptions: [
                { label: 'Perbaikan', value: 'repair' },
                { label: 'Ganti Unit Baru', value: 'replace_unit' },
            ],
        };
    },
    computed: {
        isFormValid() {
            return this.items.length > 0 && this.items.every((item) => this.isItemValid(item));
        },
    },
    methods: {
        isItemValid(item) {
            if (!item.resolutionMethod) return false;
            if (item.chargeServiceFee && !(item.serviceFee > 0)) return false;
            if (item.snBatchChanged && !item.newSnBatch.trim()) return false;
            if (item.snBatchChanged && item.cfSerialNumber && !item.newStockCode.trim()) return false;
            return true;
        },
        showModal(serviceInfo, items) {
            this.serviceInfo = serviceInfo || {};
            this.items = (items || []).map((item) => ({
                ...item,
                serialNumber: item.cfSerialNumber ? item.snBatchNumber : '',
                resolutionMethod: '',
                chargeServiceFee: false,
                serviceFee: 0,
                snBatchChanged: false,
                newSnBatch: '',
                newStockCode: '',
            }));
            $(this.$refs.modal).modal('show');
        },
        closeModal() {
            $(this.$refs.modal).modal('hide');
        },
        simpan() {
            if (!this.isFormValid || this.loading) return;
            alert({ confirmButtonColor: "blue" }).fire({
                title: "Selesaikan Semua Servis?",
                text: "Pastikan seluruh data sudah akurat. Status servis ini akan diubah menjadi Selesai dan data tidak dapat diubah kembali.",
                icon: "warning",
                showCancelButton: true,
                reverseButtons: true,
                focusConfirm: false,
                confirmButtonText: "Selesaikan Semua",
                cancelButtonText: "Cek Ulang",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$emit('simpan', this.items.map((item) => ({
                        id : item.id,
                        itemCode: Number(item.itemCode) ,
                        itemName : item.itemName,
                        itemGroup : item.itemGroup,
                        warehouseLocation : item.warehouseLocation,
                        serialNumber: this.cfSerialNumber ? item.serialNumber : '',
                        cfSerialNumber : item.cfSerialNumber,
                        batchNumber: !item.cfSerialNumber ? item.snBatchNumber : '',
                        stockCode : item.stockCode,
                        resolutionMethod: item.resolutionMethod,
                        repairedItemCode: item.repairedItemCode,
                        chargeServiceFee: item.chargeServiceFee,
                        serviceFee: item.chargeServiceFee ? item.serviceFee : 0,
                        snBatchChanged: item.snBatchChanged,
                        newSnBatch: item.snBatchChanged ? item.newSnBatch : null,
                        newStockCode: item.newStockCode ? item.newStockCode : null,
                    })));
                }
            });
        },
    },
    beforeDestroy() {
        $(this.$refs.modal).modal('hide');
    },
};
</script>

<style scoped>
.finish-service-dialog {
    max-width: 600px;
}

.finish-service-modal {
    border-radius: 16px;
    border: none;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.modal-header {
    padding: 1.5rem 1.5rem 0;
    align-items: flex-start;
}

.modal-title {
    font-size: 18px;
    font-weight: 700;
    color: #212529;
    margin-bottom: 6px;
}

.modal-subtitle {
    font-size: 13px;
    color: #6c757d;
    line-height: 1.5;
}

.modal-divider {
    margin: 1rem 0;
    border-top: 1px solid #e9ecef;
}

.modal-body {
    padding: 0 1.5rem;
    max-height: 60vh;
    overflow-y: auto;
}

.ringkasan-box {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 20px;
}

.section-header {
    background: #f8f9fa;
    padding: 10px 20px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #495057;
    border-bottom: 1px solid #e9ecef;
}

.section-body {
    padding: 16px 20px;
}

.summary-label {
    font-size: 13px;
    color: #6c757d;
    margin-bottom: 4px;
}

.summary-value {
    font-size: 14px;
    font-weight: 600;
    color: #212529;
    margin-bottom: 0;
}

.item-list-label {
    font-size: 14px;
    font-weight: 600;
    color: #212529;
    margin-bottom: 10px;
}

.item-box {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 16px;
}

.item-box:last-child {
    margin-bottom: 0;
}

.field-label {
    font-size: 13px;
    color: #6c757d;
    margin-bottom: 4px;
}

.lama-badge {
    display: inline-block;
    background: #f1f3f5;
    color: #6c757d;
    font-size: 11px;
    font-weight: 600;
    padding: 1px 8px;
    border-radius: 10px;
    margin-left: 4px;
}

.field-value {
    font-size: 14px;
    font-weight: 600;
    color: #212529;
    margin-bottom: 0;
}

.item-divider {
    border-top: 1px solid #e9ecef;
    margin: 14px 0;
}

.toggle-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
}

.toggle-label {
    font-size: 13px;
    color: #343a40;
}

.modal-footer {
    padding: 0 1.5rem 1.5rem;
    gap: 8px;
}

.btn-kembali {
    font-size: 13px;
    padding: 6px 20px;
    border-color: #dee2e6;
    color: #343a40;
}

.btn-selesaikan {
    font-size: 13px;
    padding: 6px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Service/CustomComponent/ModalFinishService.vue